import { LogIn, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
interface SignInButtonProps {
  onClick: () => void;
  disabled: boolean;
  loading: boolean;
}
export const SignInButton = ({ onClick, disabled, loading }: SignInButtonProps) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={`w-full h-14 text-lg font-semibold rounded-full transition-all duration-200 flex items-center justify-center gap-3 ${
        disabled
          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
          : 'bg-primary-blue text-white hover:bg-primary-blue/90 active:scale-95'
      }`}
    >
      {loading ? (
        <>
          <Loader2 className="w-5 h-5 animate-spin" />
          <span>Signing In...</span>
        </>
      ) : (
        <>
          <LogIn className="w-5 h-5" />
          <span className={disabled ? '' : 'text-white'}>Sign In</span>
        </>
      )}
    </Button>
  );
};